<template>
  <div>
    <v-menu
      offset-y
      left
      nudge-bottom="14"
      min-width="230"
      content-class="user-profile-menu-content"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            v-bind="attrs"
            v-on="on"
          >
            <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
          </v-avatar>
        </v-badge>
      </template>
      <v-list>
        <div class="pb-3 pt-2">
          <v-badge
            bottom
            color="success"
            overlap
            offset-x="12"
            offset-y="12"
            class="ms-4"
            dot
          >
            <v-avatar size="40px">
              <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
            </v-avatar>
          </v-badge>
          <div
            class="d-inline-flex flex-column justify-center ms-3"
            style="vertical-align:middle"
          >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ name }}
          </span>
            <small class="text--disabled text-capitalize">{{ position }}</small>
          </div>
        </div>

        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-list-item link v-if=" position==='ADMIN'"
                     @click="load_transmital_or_dialog = true ">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiContentSaveMove }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Load Transmital Or</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link
                     v-if="position==='BRANCH MANAGER'  && date_is_can_new_month"
                     @click="start_new_month_transaction">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiReload }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Start New Month Transaction</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
        <v-list-item link @click="is_change_password = true">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiCogOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Change Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2"></v-divider>
        <v-list-item link @click="downloadTextFile" v-if="position==='ADMIN'||position==='BRANCH MANAGER'">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiCogOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>(Not yet done)Generate CISA txt file</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2"></v-divider>

        <!-- Logout -->
        <v-list-item link @click="logout">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiLogoutVariant }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <!--    dialog here-->
    <v-dialog v-model="is_change_password" persistent max-width="50%">
      <ChangePassword></ChangePassword>
    </v-dialog>
    <v-dialog v-model="show" persistent width="50%" dark>
      <v-card color="primary">
        <v-card-text>
          {{ txt }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <restore-db-file-dialog
      v-on:dialog_value="on_restore_db_file_close"
      :dialog_show="restore_db_file_dialog"
    />
    <load-transmital-or
      v-on:dialog_value="on_restore_db_file_close"
      :dialog_show="load_transmital_or_dialog"
    />
  </div>
</template>

<script>
import {
  mdiContentSave,
  mdiContentSaveMove,
  mdiChatOutline,
  mdiCogOutline,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiReload,
} from '@mdi/js'
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import ChangePassword from '@/views/dashboard/ChangePassword'
import restoreDbFileDialog from '../../components/dialogs/RestoreDbFile'
import loadTransmitalOr from '../../components/dialogs/LoadTransmitalOr'

export default {
  components: {
    restoreDbFileDialog,
    loadTransmitalOr,
    ChangePassword,
  },
  data() {
    return {
      is_change_password: false,
      show: false,
      txt: '',
      date_is_can_new_month: false,
      load_transmital_or_dialog: false,
      restore_db_file_dialog: false,
      months_items: [],

      icons: {
        mdiContentSave,
        mdiContentSaveMove,
        mdiReload,
        mdiChatOutline,
        mdiCogOutline,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },
  mounted() {
    this.conditions_for_new_month()
  },
  watch: {
    month_end: function () {
      this.conditions_for_new_month()
    },
  },
  computed: {
    ...mapGetters('authentication', ['name', 'position', 'id_no', 'branch_id', 'branch', 'can_new_month', 'month_start', 'month_end', 'month_of']),
  },
  methods: {
    ...mapActions('authentication', ['logout_credentials']),
    ...mapActions('coop_savings_protect_m_c_r_s', ['get_CoopSavingsProtect_current_MCR']),
    ...mapActions('monthly_collection_reports', ['monthly_collection_report']),
    ...mapActions('monthly_quota_reports', ['monthly_quota_report']),
    ...mapActions('transaction_months', ['start_new_transaction_month', 'retrieve_transaction_month']),
    ...mapActions('loans_payment', ['start_new_month_loan_payments']),
    ...mapActions('start_new_month', ['is_can_new_month', 'sendText']),
    ...mapActions('db_file', ['create_db_file']),
    ...mapActions('monthly_collection_reports', ['previous_monthly_collection_report']),
    on_restore_db_file_close(value) {
      this.restore_db_file_dialog = value
    },
    conditions_for_new_month() {
      var end_date = moment(this.month_end, 'MMMM DD, YYYY');
      if (moment(end_date).isBefore(moment())) {
        this.date_is_can_new_month = true
      }
      this.retrieve_transaction_month()
        .then(response => {
          this.months_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatDate(date) {

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const dd = String(date.getDate()).padStart(2, '0');
      const HH = String(date.getHours()).padStart(2, '0');
      const MM = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');

      return `${yyyy}${mm}${dd}${HH}${MM}${ss}`;
    },
    generateLetterVars() {
      const vars = {};
      const toLetter = (n) => {
        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % 26) + 97) + s;
          n = Math.floor(n / 26) - 1;
        }
        return s;
      };
      for (let i = 0; i <= 143; i++) {
        const name = toLetter(i);
        vars[name] = '';
        if (name === 'em') break; // stop at 'em'
      }
      return vars;
    },
    async downloadTextFile() {
      const hd = this.generateLetterVars()
      const id = this.generateLetterVars()
      const ci = this.generateLetterVars()
      const ft = this.generateLetterVars()
      const provider_code = 'CO123456'
      const reference_date = '31122024'
      const branch_code = ''
      let counter = 0

      hd.a = 'HD'
      hd.b = provider_code
      hd.c = reference_date
      hd.d = '1.0'
      hd.e = '0'
      hd.f = 'December 2024 Report'

      let content = hd.a + '|' + hd.b + '|' + hd.c + '|' + hd.d + '|' + hd.e + '|' + hd.f + '|' + hd.g + '|' + hd.h + '|' + hd.i + '|' + hd.j + '|' + hd.k + '|' + hd.l + '|' + hd.m + '|' + hd.n + '|' + hd.o + '|' + hd.p + '|' + hd.q + '|' + hd.r + '|' + hd.s + '|' + hd.t + '|' + hd.u + '|' + hd.v + '|' + hd.w + '|' + hd.x + '|' + hd.y + '|' + hd.z + '|' + hd.aa + '|' + hd.ab + '|' + hd.ac + '|' + hd.ad + '|' + hd.ae + '|' + hd.af + '|' + hd.ag + '|' + hd.ah + '|' + hd.ai + '|' + hd.aj + '|' + hd.ak + '|' + hd.al + '|' + hd.am + '|' + hd.an + '|' + hd.ao + '|' + hd.ap + '|' + hd.aq + '|' + hd.ar + '|' + hd.as + '|' + hd.at + '|' + hd.au + '|' + hd.av + '|' + hd.aw + '|' + hd.ax + '|' + hd.ay + '|' + hd.az + '|' + hd.ba + '|' + hd.bb + '|' + hd.bc + '|' + hd.bd + '|' + hd.be + '|' + hd.bf + '|' + hd.bg + '|' + hd.bh + '|' + hd.bi + '|' + hd.bj + '|' + hd.bk + '|' + hd.bl + '|' + hd.bm + '|' + hd.bn + '|' + hd.bo + '|' + hd.bp + '|' + hd.bq + '|' + hd.br + '|' + hd.bs + '|' + hd.bt + '|' + hd.bu + '|' + hd.bv + '|' + hd.bw + '|' + hd.bx + '|' + hd.by + '|' + hd.bz + '|' + hd.ca + '|' + hd.cb + '|' + hd.cc + '|' + hd.cd + '|' + hd.ce + '|' + hd.cf + '|' + hd.cg + '|' + hd.ch + '|' + hd.ci + '|' + hd.cj + '|' + hd.ck + '|' + hd.cl + '|' + hd.cm + '|' + hd.cn + '|' + hd.co + '|' + hd.cp + '|' + hd.cq + '|' + hd.cr + '|' + hd.cs + '|' + hd.ct + '|' + hd.cu + '|' + hd.cv + '|' + hd.cw + '|' + hd.cx + '|' + hd.cy + '|' + hd.cz + '|' + hd.ea + '|' + hd.eb + '|' + hd.ec + '|' + hd.ed + '|' + hd.ee + '|' + hd.ef + '|' + hd.eg + '|' + hd.eh + '|' + hd.ei + '|' + hd.ej + '|' + hd.ek + '|' + hd.el + '|' + hd.em;
      let content2 = ''
      const data = new FormData()
      data.append('branch_id', this.branch_id);
      data.append('month_of', this.months_items[1].month_of);
      data.append('month_start', this.months_items[1].month_start);
      data.append('is_new_month', 0);
      data.append('collector_id', 0);
      data.append('type_of_loan', 'All');
      data.append('specify_type_of_loan', '');
      data.append('sorted_by', '');
      await this.previous_monthly_collection_report(data)
        .then(response => {
          response.data.forEach(function (item) {
            if (item.loans_planned_end != null) {
              counter++
              const provider_subject_no = 'GSCC' + item.cmf_no.replace(/-/g, '');
              id.a = 'ID'
              id.b = provider_code
              id.c = branch_code
              id.d = reference_date
              id.e = provider_subject_no
              id.f = item.members.gender === 'Male' ? 10 : 11
              id.g = item.members.first_name
              id.h = item.members.last_name
              id.i = item.members.middle_name
              id.m = item.members.gender
              id.n = moment(item.members.date_of_birth, 'MMMM DD, YYYY').format('DDMMYYYY')
              id.o = item.members.place_of_birth
              id.p = 'PH'
              id.q = 'PH'
              id.r = '0'
              id.s = item.members.civil_status === 'Single' ? 1 : (item.members.civil_status === 'Married' ? '2' : (item.members.civil_status === 'Widow' ? '4' : '3'))
              id.t = item.members.no_of_dependents
              id.af = 'MI'
              id.ag = item.members.present_address
              id.aq = 'AI'
              id.ar = item.members.permanent_address
              id.bb = '10'
              id.bc = item.members.tin_no
              id.bz = '3'
              id.bc = item.members.contact_no
              id.cb = '3'
              id.cc = item.members.contact_no

              ci.a = 'CI'
              ci.b = provider_code
              ci.c = branch_code
              ci.d = reference_date
              ci.e = provider_subject_no
              ci.f = 'B'
              ci.g = item.application_no.replace(/-/g, '');
              ci.h = item.type_of_loan === 'Personal' ? '12' : (item.type_of_loan === 'Business' ? '22' : (item.type_of_loan === 'Salary (GOODLIFE)' ? '20' : ('15')))
              ci.i = 'AC'
              ci.k = 'PHP'
              ci.l = 'PHP'
              ci.m = item.loan_start_date
              ci.n = item.loan_request_date
              ci.o = item.loans_planned_end
              ci.p = item.loans_actual_end
              ci.q = item.last_payment_date
              ci.t = parseInt(item.loan_data.amount)
              ci.u = parseInt(item.loan_data.terms)
              ci.v = 'NA'
              ci.x = item.loan_data.mode_of_loan === '15/30' ? 'F' : (item.loan_data.mode_of_loan === 'Monthly' ? 'M' : ('W'))
              ci.y = 'CAS'
              ci.z = parseInt(item.loan_data.amount_due)
              ci.ab = parseInt(item.last_payment_amount)
              ci.ae = parseInt(item.remaining_not_yet_paid)
              ci.af = parseInt(item.currency_balance.replace(/,/g, ''))

              content = content + '\n' + id.a + '|' + id.b + '|' + id.c + '|' + id.d + '|' + id.e + '|' + id.f + '|' + id.g + '|' + id.h + '|' + id.i + '|' + id.j + '|' + id.k + '|' + id.l + '|' + id.m + '|' + id.n + '|' + id.o + '|' + id.p + '|' + id.q + '|' + id.r + '|' + id.s + '|' + id.t + '|' + id.u + '|' + id.v + '|' + id.w + '|' + id.x + '|' + id.y + '|' + id.z + '|' + id.aa + '|' + id.ab + '|' + id.ac + '|' + id.ad + '|' + id.ae + '|' + id.af + '|' + id.ag + '|' + id.ah + '|' + id.ai + '|' + id.aj + '|' + id.ak + '|' + id.al + '|' + id.am + '|' + id.an + '|' + id.ao + '|' + id.ap + '|' + id.aq + '|' + id.ar + '|' + id.as + '|' + id.at + '|' + id.au + '|' + id.av + '|' + id.aw + '|' + id.ax + '|' + id.ay + '|' + id.az + '|' + id.ba + '|' + id.bb + '|' + id.bc + '|' + id.bd + '|' + id.be + '|' + id.bf + '|' + id.bg + '|' + id.bh + '|' + id.bi + '|' + id.bj + '|' + id.bk + '|' + id.bl + '|' + id.bm + '|' + id.bn + '|' + id.bo + '|' + id.bp + '|' + id.bq + '|' + id.br + '|' + id.bs + '|' + id.bt + '|' + id.bu + '|' + id.bv + '|' + id.bw + '|' + id.bx + '|' + id.by + '|' + id.bz + '|' + id.ca + '|' + id.cb + '|' + id.cc + '|' + id.cd + '|' + id.ce + '|' + id.cf + '|' + id.cg + '|' + id.ch + '|' + id.ci + '|' + id.cj + '|' + id.ck + '|' + id.cl + '|' + id.cm + '|' + id.cn + '|' + id.co + '|' + id.cp + '|' + id.cq + '|' + id.cr + '|' + id.cs + '|' + id.ct + '|' + id.cu + '|' + id.cv + '|' + id.cw + '|' + id.cx + '|' + id.cy + '|' + id.cz + '|' + id.ea + '|' + id.eb + '|' + id.ec + '|' + id.ed + '|' + id.ee + '|' + id.ef + '|' + id.eg + '|' + id.eh + '|' + id.ei + '|' + id.ej + '|' + id.ek + '|' + id.el + '|' + id.em;
              content2 = content2 + '\n' + ci.a + '|' + ci.b + '|' + ci.c + '|' + ci.d + '|' + ci.e + '|' + ci.f + '|' + ci.g + '|' + ci.h + '|' + ci.i + '|' + ci.j + '|' + ci.k + '|' + ci.l + '|' + ci.m + '|' + ci.n + '|' + ci.o + '|' + ci.p + '|' + ci.q + '|' + ci.r + '|' + ci.s + '|' + ci.t + '|' + ci.u + '|' + ci.v + '|' + ci.w + '|' + ci.x + '|' + ci.y + '|' + ci.z + '|' + ci.aa + '|' + ci.ab + '|' + ci.ac + '|' + ci.ad + '|' + ci.ae + '|' + ci.af + '|' + ci.ag + '|' + ci.ah + '|' + ci.ai + '|' + ci.aj + '|' + ci.ak + '|' + ci.al + '|' + ci.am + '|' + ci.an + '|' + ci.ao + '|' + ci.ap + '|' + ci.aq + '|' + ci.ar + '|' + ci.as + '|' + ci.at + '|' + ci.au + '|' + ci.av + '|' + ci.aw + '|' + ci.ax + '|' + ci.ay + '|' + ci.az + '|' + ci.ba + '|' + ci.bb + '|' + ci.bc + '|' + ci.bd + '|' + ci.be + '|' + ci.bf + '|' + ci.bg + '|' + ci.bh + '|' + ci.bi + '|' + ci.bj + '|' + ci.bk + '|' + ci.bl + '|' + ci.bm + '|' + ci.bn + '|' + ci.bo + '|' + ci.bp + '|' + ci.bq + '|' + ci.br + '|' + ci.bs + '|' + ci.bt + '|' + ci.bu + '|' + ci.bv + '|' + ci.bw + '|' + ci.bx + '|' + ci.by + '|' + ci.bz + '|' + ci.ca + '|' + ci.cb + '|' + ci.cc + '|' + ci.cd + '|' + ci.ce + '|' + ci.cf + '|' + ci.cg + '|' + ci.ch + '|' + ci.ci + '|' + ci.cj + '|' + ci.ck + '|' + ci.cl + '|' + ci.cm + '|' + ci.cn + '|' + ci.co + '|' + ci.cp + '|' + ci.cq + '|' + ci.cr + '|' + ci.cs + '|' + ci.ct + '|' + ci.cu + '|' + ci.cv + '|' + ci.cw + '|' + ci.cx + '|' + ci.cy + '|' + ci.cz + '|' + ci.ea + '|' + ci.eb + '|' + ci.ec + '|' + ci.ed + '|' + ci.ee + '|' + ci.ef + '|' + ci.eg + '|' + ci.eh + '|' + ci.ei + '|' + ci.ej + '|' + ci.ek + '|' + ci.el + '|' + ci.em;
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
      ft.a = 'FT'
      ft.b = provider_code
      ft.c = reference_date
      ft.d = counter * 2
      content2 = content2 + '\n' + ft.a + '|' + ft.b + '|' + ft.c + '|' + ft.d + '|' + ft.e + '|' + ft.f + '|' + ft.g + '|' + ft.h + '|' + ft.i + '|' + ft.j + '|' + ft.k + '|' + ft.l + '|' + ft.m + '|' + ft.n + '|' + ft.o + '|' + ft.p + '|' + ft.q + '|' + ft.r + '|' + ft.s + '|' + ft.t + '|' + ft.u + '|' + ft.v + '|' + ft.w + '|' + ft.x + '|' + ft.y + '|' + ft.z + '|' + ft.aa + '|' + ft.ab + '|' + ft.ac + '|' + ft.ad + '|' + ft.ae + '|' + ft.af + '|' + ft.ag + '|' + ft.ah + '|' + ft.ai + '|' + ft.aj + '|' + ft.ak + '|' + ft.al + '|' + ft.am + '|' + ft.an + '|' + ft.ao + '|' + ft.ap + '|' + ft.aq + '|' + ft.ar + '|' + ft.as + '|' + ft.at + '|' + ft.au + '|' + ft.av + '|' + ft.aw + '|' + ft.ax + '|' + ft.ay + '|' + ft.az + '|' + ft.ba + '|' + ft.bb + '|' + ft.bc + '|' + ft.bd + '|' + ft.be + '|' + ft.bf + '|' + ft.bg + '|' + ft.bh + '|' + ft.bi + '|' + ft.bj + '|' + ft.bk + '|' + ft.bl + '|' + ft.bm + '|' + ft.bn + '|' + ft.bo + '|' + ft.bp + '|' + ft.bq + '|' + ft.br + '|' + ft.bs + '|' + ft.bt + '|' + ft.bu + '|' + ft.bv + '|' + ft.bw + '|' + ft.bx + '|' + ft.by + '|' + ft.bz + '|' + ft.ca + '|' + ft.cb + '|' + ft.cc + '|' + ft.cd + '|' + ft.ce + '|' + ft.cf + '|' + ft.cg + '|' + ft.ch + '|' + ft.ci + '|' + ft.cj + '|' + ft.ck + '|' + ft.cl + '|' + ft.cm + '|' + ft.cn + '|' + ft.co + '|' + ft.cp + '|' + ft.cq + '|' + ft.cr + '|' + ft.cs + '|' + ft.ct + '|' + ft.cu + '|' + ft.cv + '|' + ft.cw + '|' + ft.cx + '|' + ft.cy + '|' + ft.cz + '|' + ft.ea + '|' + ft.eb + '|' + ft.ec + '|' + ft.ed + '|' + ft.ee + '|' + ft.ef + '|' + ft.eg + '|' + ft.eh + '|' + ft.ei + '|' + ft.ej + '|' + ft.ek + '|' + ft.el + '|' + ft.em;
      const blob = new Blob([content + content2], {type: 'text/plain'});
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = provider_code + '_CSDF_' + this.formatDate(new Date()) + '.txt';
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    tool_generate_db() {
      this.show = true
      this.txt = 'Generating...Please Wait...'
      this.create_db_file({
        file_name: 'goodlife-coop-' + moment().format('MM-DD-YYYY-hh-mm-ss') + '.pptx',
      })
        .then(() => {
          this.txt = ''
          this.show = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    logout() {
      this.show = true
      this.txt = 'LOGGING OUT.....'

      const data = new FormData()
      data.append('id_no', this.id_no);
      this.logout_credentials(data)
        .then(() => {
          this.$router.push({path: '/'})
          this.show = false
          this.txt = ''
        })
        .catch(error => {
          console.log(error)
          this.show = false
          this.txt = ''
        })
    },
    start_new_month_transaction() {
      var start = moment().clone().startOf('month').format('MMMM DD, YYYY')
      var end = moment().clone().endOf('month').format('MMMM DD, YYYY')


      const data3 = new FormData()
      data3.append('branch_id', this.branch_id);
      this.is_can_new_month(data3)
        .then(resolve => {
          if (resolve.data[0].proceed) {
            this.show = true
            this.txt = 'COLLECTING DATA & SAVING DATA ON MONTHLY COLLECTION REPORTS'

            const data = new FormData()
            data.append('branch_id', this.branch_id);
            data.append('month_of', this.month_of);
            data.append('month_end', this.month_end);
            data.append('is_new_month', 1);
            data.append('type_of_loan', '');
            data.append('collector_id', 0);
            this.get_CoopSavingsProtect_current_MCR(data)
            this.monthly_collection_report(data)
              .then(() => {
                this.show = true
                this.txt = 'COLLECTING DATA & SAVING DATA ON MONTHLY QUOTA REPORTS'
                data.append('is_new_month', 2);
                this.monthly_quota_report(data)
                  .then(() => {
                    this.monthly_collection_report(data)
                      .then(() => {
                        this.show = true
                        this.txt = 'GENERATE PENALTIES OF UNPAID LOANS'
                        this.start_new_month_loan_payments(data)
                          .then(() => {
                            const data2 = new FormData()
                            data2.append('month_of', moment().format('MMMM YYYY'));
                            data2.append('year', moment().year());
                            data2.append('month_start', start);
                            data2.append('month_end', end);
                            data2.append('branch_id', this.branch_id);
                            this.txt = 'STARTING NEW MONTH TRANSACTIONS...'
                            this.start_new_transaction_month(data2)
                              .then(response => {
                                data.append('month_of', this.month_of);
                                this.sendText(data)
                                this.txt = response.data + ' AND AUTOMATICALLY LOGOUT!'
                                this.logout()
                              })
                              .catch(error => {
                                console.log(error)
                              })
                          })
                          .catch(error => {
                            console.log(error)
                          })
                      })
                      .catch(error => {
                        console.log(error)
                      })
                  })
                  .catch(error => {
                    console.log(error)
                  })
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            this.show = true
            this.txt = resolve.data[0].message

            if (this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              this.txt = ''
              this.show = false
            }, 2000)

          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
